import { useAccount } from "@azure/msal-react";
import * as React from "react";
import { ErrorTypes } from "../../components/errors/ErrorTypes";
import ErrorPage from "../../components/errors/errorPage/ErrorPage";
import Feature from "../permissions/Feature";
import { hasUserDataWallAccess, hasUserPermission } from "../permissions/permissions";

const PermissionTemplate: React.FC = ({ children }) => {
  const activeAccount = useAccount();

  const hasUserAccess = (): boolean => {
    let access = hasUserDataWallAccess() && hasUserPermission(Feature.USER_HAS_MARKETPLACE_ACCESS);

    if (process.env.APP === "mus") {
      access = access && hasUserPermission(Feature.USER_HAS_MUS_ACCESS);
    }

    return access;
  };

  return <>{hasUserAccess() && activeAccount ? children : <ErrorPage type={ErrorTypes.e403} />}</>;
};

export default PermissionTemplate;
